import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {QuestListItem} from "../../interfaces/quest-list-item";

@Component({
  selector: 'brt-quests-list',
  templateUrl: './quests-list.component.html',
  styleUrls: ['./quests-list.component.scss']
})
export class QuestsListComponent implements Overlayable {
    @Output('onClosed') onClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input('items') set setItems(items: QuestListItem[]) {
      this.items = items;
    }

    @Input('isPublic') isPublic: boolean = false;

    items: QuestListItem[] = [];
}
